import { render, staticRenderFns } from "./PasswordLogin.vue?vue&type=template&id=10f25cae&scoped=true"
import script from "./PasswordLogin.vue?vue&type=script&lang=js"
export * from "./PasswordLogin.vue?vue&type=script&lang=js"
import style0 from "./PasswordLogin.vue?vue&type=style&index=0&id=10f25cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f25cae",
  null
  
)

export default component.exports